export const GroupColor = ['#442C1B', '#7F5347', '#8A0303', '#BB3354', '#E2445C', '#FF642E', '#FF7575', '#FDAB3D', '#CAB641', '#E6E200', '#A4D3A8',
  '#9CD326', '#037F4C', '#00C875', '#4ECCC6', '#006D77', '#0086C0', '#579BFC', '#5559DF', '#7E3B8A', '#401694', '#FAA1F1', '#FF5AC4', '#A25DDC',
  '#D20BFF', '#718815', '#9AADBD'];
